var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.786,
    height: 25.641,
    viewBox: "0 0 36.786 25.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.542,
    y1: 0.065,
    x2: 0.5,
    y2: 0.827,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797",
    transform: "translate(-11347.756 22125.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M12.675,14.866c-2.19,1.821-6.456-.3-9.933-4.409S.084,0,.084,0,6.54.3,10.017,4.409s4.848,8.637,2.658,10.457",
    transform: "translate(11355.069 -22121.068)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M4.749,19.406c2.859,0,4.749-4.344,4.749-9.7S4.749,0,4.749,0,0,4.344,0,9.7s1.89,9.7,4.749,9.7",
    transform: "translate(11361.4 -22124.949)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M1.057,14.866c2.19,1.821,6.456-.3,9.933-4.409S13.648,0,13.648,0,7.192.3,3.716,4.409s-4.849,8.637-2.659,10.457",
    transform: "translate(11363.496 -22121.068)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M0,3.786A10.555,10.555,0,0,1,.746,0,10.689,10.689,0,0,1,3.686,2.375c3.477,4.1,4.849,8.636,2.658,10.457a2.9,2.9,0,0,1-1.737.649C1.828,13.339,0,9.055,0,3.786",
    transform: "translate(11361.4 -22119.031)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M7.4,3.786A10.571,10.571,0,0,0,6.656,0a10.7,10.7,0,0,0-2.94,2.375C.238,6.48-1.133,11.011,1.058,12.832a2.9,2.9,0,0,0,1.738.649C5.574,13.339,7.4,9.055,7.4,3.786",
    transform: "translate(11363.496 -22119.031)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M2.647,13.907.657,8.681C-.747,6.891.183,3.42,2.647,0c2.464,3.42,3.394,6.891,1.99,8.681Z",
    transform: "translate(11363.503 -22115.299)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M0,11.817c-.1-3.106,1.955-6.746,5.566-9.25S13.335-.609,16.246.55a20.572,20.572,0,0,0-9.418,3.8A20.332,20.332,0,0,0,0,11.817",
    transform: "translate(11366.152 -22113.012)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M16.243,11.817c.1-3.106-1.956-6.746-5.566-9.25S2.911-.609,0,.55a20.573,20.573,0,0,1,9.418,3.8,20.335,20.335,0,0,1,6.824,7.47",
    transform: "translate(11349.9 -22113.012)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasic);
export default __webpack_public_path__ + "static/media/basic.7e9769b552bd4696e920e7b932579531.svg";
export { ForwardRef as ReactComponent };